export default __webpack_public_path__ + "static/media/path-2.b7f78d82.png";